module.exports = __webpack_public_path__ + "static/media/signout.d077a678.svg";